// extracted by mini-css-extract-plugin
export default {"CurrencySelector":"CurrencySelector_CurrencySelector__KRUl2"};